// =============================================================================
// TREASURY PAGES LAYOUTS
// =============================================================================

import {isMobile} from '@/prototypes/u/other'

export default {
  path: 'treasury',
  component: () => import('../../../views/admin/treasury/index.vue'),
  children: [
    {
      path: '',
      redirect: '/error-404'
    },
    {
      path: 'banks',
      component: () => import('../../../views/admin/treasury/banks/index.vue'),
      children: [
        {
          path: '',
          name: 'treasuryBanks',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileTreasuryBanks" */ '@/mobile/views/admin/treasury/banks/list/banksList.vue') : import(/* webpackChunkName: "desktopTreasuryBanks" */ '@/desktop/views/admin/treasury/banks/list/banksList.vue') },
          meta: {
            permission: 'bank.show',
            pageTitle: 'بانک ها',
            pageTitleI18n: 'pages.treasury.banks.title'
          // rule: 'editor'
          }
        },
        {
          path: 'insert',
          name: 'insertTreasuryBank',
          component: () => import(/* webpackChunkName: "insertTreasuryBank" */ '../../../views/admin/treasury/banks/insert/insertBank.vue'),
          meta: {
            permission: 'bank.create',
            pageTitle: 'افزودن بانک',
            pageTitleI18n: 'pages.treasury.banks.insert.title'
          // rule: 'editor'
          }
        },
        {
          path: 'trash',
          name: 'treasuryBankTrash',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileTreasuryBankTrash" */ '@/mobile/views/admin/treasury/banks/trash/banksTrash.vue') : import(/* webpackChunkName: "desktopTreasuryBankTrash" */ '@/desktop/views/admin/treasury/banks/trash/banksTrash.vue') },
          meta: {
            permission: 'bank.delete',
            pageTitle: 'سطل زباله بانک ها',
            pageTitleI18n: 'pages.treasury.banks.trash.title'
          // rule: 'editor'
          }
        },
        {
          path: ':id',
          component: () => { return isMobile() ?  import('@/mobile/views/admin/treasury/banks/bank/index.vue') : import('@/desktop/views/admin/treasury/banks/bank/index.vue') },
          meta: {
            redirectNotFound: true
          },
          children: [
            {
              path: '',
              name: 'treasuryBank',
              component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileTreasuryBank" */ '@/mobile/views/admin/treasury/banks/bank/profile/bankMenu.vue') : import(/* webpackChunkName: "desktopTreasuryBank" */ '@/desktop/views/admin/treasury/banks/bank/profile/bankMenu.vue') },
              meta: {
                permission: 'bank.show',
                pageTitle: 'بانک',
                pageTitleI18n: 'pages.treasury.banks.bank.title',
                layoutStatus: 'profile'
              // rule: 'editor'
              }
            },
            {
              path: 'edit',
              name: 'editTreasuryBank',
              component: () => import(/* webpackChunkName: "editTreasuryBank" */ '../../../views/admin/treasury/banks/bank/edit/editBank.vue'),
              meta: {
                permission: 'bank.update',
                pageTitle: 'ویرایش بانک',
                pageTitleI18n: 'pages.treasury.banks.edit.title',
                layoutStatus: 'profile'
              // rule: 'editor'
              }
            },
            {
              path: 'transactions',
              name: 'transactionsTreasuryBank',
              component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileTreasuryBankTransactions" */ '@/mobile/views/admin/treasury/banks/bank/transactions/bankTransactions.vue') : import(/* webpackChunkName: "desktopTreasuryBankTransactions" */ '@/desktop/views/admin/treasury/banks/bank/transactions/bankTransactions.vue') },
              meta: {
                permission: 'bank.show',
                pageTitle: '',
                pageTitleI18n: 'pages.treasury.banks.transactions.title',
                layoutStatus: 'profile'
              // rule: 'editor'
              }
            },
            {
              path: 'activities-log',
              name: 'BankActivitiesLog',
              component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileBankActivitiesLog" */ '@/mobile/views/admin/treasury/banks/bank/activitiesLog/bankActivitiesLog.vue') : import(/* webpackChunkName: "desktopBankActivitiesLog" */ '@/desktop/views/admin/treasury/banks/bank/activitiesLog/bankActivitiesLog.vue') },
              meta: {
                permission: 'activity_logs.show',
                pageTitle: 'لاگ های بانک',
                pageTitleI18n: 'pages.treasury.banks.logs.title',
                layoutStatus: 'profile'
              // rule: 'editor'
              }
            }
          ]
        }
      ]
    },
    {
      path: 'payment-gateways',
      component: () => import('../../../views/admin/treasury/paymentGateways/index.vue'),
      children: [
        {
          path: '',
          name: 'paymentGateways',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobilePaymentGateways" */ '@/mobile/views/admin/treasury/paymentGateways/list/paymentGateways.vue') : import(/* webpackChunkName: "desktopPaymentGateways" */ '@/desktop/views/admin/treasury/paymentGateways/list/paymentGateways.vue') },
          meta: {
            permission: 'payment_gateway.show',
            pageTitle: 'درگاه های پرداخت',
            pageTitleI18n: 'pages.treasury.paymentGateways.title'
          // rule: 'editor'
          }
        },
        {
          path: 'insert',
          name: 'insertPaymentGateway',
          component: () => import(/* webpackChunkName: "insertPaymentGateway" */ '../../../views/admin/treasury/paymentGateways/insert/insertPaymentGateway.vue'),
          meta: {
            permission: 'payment_gateway.create',
            pageTitle: 'افزودن درگاه پرداخت',
            pageTitleI18n: 'pages.treasury.paymentGateways.insert.title'
          // rule: 'editor'
          }
        },
        {
          path: 'trash',
          name: 'trashedPaymentGateways',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobilePaymentGatewaysTrash" */ '@/mobile/views/admin/treasury/paymentGateways/trash/trashedPaymentGateways.vue') : import(/* webpackChunkName: "desktopPaymentGatewaysTrash" */ '@/desktop/views/admin/treasury/paymentGateways/trash/trashedPaymentGateways.vue') },
          meta: {
            permission: 'payment_gateway.delete',
            pageTitle: 'سطل زباله درگاه های پرداخت',
            pageTitleI18n: 'pages.treasury.paymentGateways.trash.title'
          // rule: 'editor'
          }
        },
        {
          path: ':id',
          component: () => { return isMobile() ?  import('@/mobile/views/admin/treasury/paymentGateways/paymentGateway/index.vue') : import('@/desktop/views/admin/treasury/paymentGateways/paymentGateway/index.vue') },
          meta: {
            redirectNotFound: true
          },
          children: [
            {
              path: '',
              name: 'paymentGateway',

              component: () => { return isMobile() ?  import(/* webpackChunkName: "mobilePaymentGateway" */ '@/mobile/views/admin/treasury/paymentGateways/paymentGateway/profile/paymentGateway.vue') : import(/* webpackChunkName: "desktopPaymentGateway" */ '@/desktop/views/admin/treasury/paymentGateways/paymentGateway/profile/paymentGateway.vue') },
              meta: {
                permission: 'payment_gateway.show',
                pageTitle: 'درگاه پرداخت',
                pageTitleI18n: 'pages.treasury.paymentGateways.paymentGateway.title',
                layoutStatus: 'profile'
              // rule: 'editor'
              }
            },
            {
              path: 'edit',
              name: 'editPaymentGateway',
              component: () => import(/* webpackChunkName: "editPaymentGateway" */ '../../../views/admin/treasury/paymentGateways/paymentGateway/edit/editPaymentGateway.vue'),
              meta: {
                permission: 'payment_gateway.update',
                pageTitle: 'ویرایش درگاه پرداخت',
                pageTitleI18n: 'pages.treasury.paymentGateways.edit.title',
                layoutStatus: 'profile'
              // rule: 'editor'
              }
            },
            {
              path: 'transactions',
              name: 'transactionsPaymentGateway',
              component: () => { return isMobile() ?  import(/* webpackChunkName: "mobilePaymentGatewayTransactions" */ '@/mobile/views/admin/treasury/paymentGateways/paymentGateway/transactions/paymentGatewayTransactions.vue') : import(/* webpackChunkName: "desktopPaymentGatewayTransactions" */ '@/desktop/views/admin/treasury/paymentGateways/paymentGateway/transactions/paymentGatewayTransactions.vue') },
              meta: {
                permission: 'payment_gateway.show',
                pageTitle: 'گردش مالی درگاه پرداخت',
                pageTitleI18n: 'pages.treasury.paymentGateways.transactions.title',
                layoutStatus: 'profile'
              // rule: 'editor'
              }
            },
            {
              path: 'receive',
              name: 'receivePaymentGateway',
              component: () => import(/* webpackChunkName: "transactionsPaymentGateway" */ '../../../views/admin/treasury/paymentGateways/paymentGateway/receive/receivedPaymentGatewayBalance.vue'),
              meta: {
                permission: 'payment_gateway.show',
                pageTitle: 'اعلام وصول درگاه پرداخت',
                pageTitleI18n: 'pages.treasury.paymentGateways.receive.title',
                layoutStatus: 'profile'
              // rule: 'editor'
              }
            },
            {
              path: 'activities-log',
              name: 'activitiesLogPaymentGateway',
              component: () => { return isMobile() ?  import(/* webpackChunkName: "mobilePaymentGatewayActivitiesLog" */ '@/mobile/views/admin/treasury/paymentGateways/paymentGateway/activitiesLog/paymentGatewayActivitiesLog.vue') : import(/* webpackChunkName: "desktopPaymentGatewayActivitiesLog" */ '@/desktop/views/admin/treasury/paymentGateways/paymentGateway/activitiesLog/paymentGatewayActivitiesLog.vue') },
              meta: {
                permission: 'activity_logs.show',
                pageTitle: 'لاگ های درگاه پرداخت',
                pageTitleI18n: 'pages.treasury.paymentGateways.logs.title',
                layoutStatus: 'profile'
              // rule: 'editor'
              }
            }
          ]
        }
      ]
    },
    {
      path: 'cash_boxes',
      component: () => import('../../../views/admin/treasury/cashBoxes/index.vue'),
      children: [
        {
          path: '',
          name: 'treasuryCashBoxes',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileTreasuryCashBoxes" */ '@/mobile/views/admin/treasury/cashBoxes/list/cashBoxList.vue') : import(/* webpackChunkName: "desktopTreasuryCashBoxes" */ '@/desktop/views/admin/treasury/cashBoxes/list/cashBoxList.vue') },
          meta: {
            permission: 'cash.show',
            pageTitle: 'صندوق ها',
            pageTitleI18n: 'pages.treasury.cashBoxes.title'
          // rule: 'editor'
          }
        },
        {
          path: 'insert',
          name: 'insertTreasuryCashBox',
          component: () => import(/* webpackChunkName: "insertTreasuryCashBox" */ '../../../views/admin/treasury/cashBoxes/insert/insertCashBox.vue'),
          meta: {
            permission: 'cash.create',
            pageTitle: 'افزودن صندوق',
            pageTitleI18n: 'pages.treasury.cashBoxes.insert.title'
          // rule: 'editor'
          }
        },
        {
          path: 'trash',
          name: 'treasuryCashBoxTrash',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileTreasuryCashBoxTrash" */ '@/mobile/views/admin/treasury/cashBoxes/trash/cashBoxesTrash.vue') : import(/* webpackChunkName: "desktopTreasuryCashBoxTrash" */ '@/desktop/views/admin/treasury/cashBoxes/trash/cashBoxesTrash.vue') },
          meta: {
            permission: 'cash.delete',
            pageTitle: 'سطل زباله صندوق ها',
            pageTitleI18n: 'pages.treasury.cashBoxes.trash.title'
          // rule: 'editor'
          }
        },
        {
          path: ':id',
          component: () => { return isMobile() ?  import('@/mobile/views/admin/treasury/cashBoxes/cashBox/index.vue') : import('@/desktop/views/admin/treasury/cashBoxes/cashBox/index.vue') },
          meta: {
            redirectNotFound: true
          },
          children: [
            {
              path: '',
              name: 'treasuryCashBox',
              component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileTreasuryCashBox" */ '@/mobile/views/admin/treasury/cashBoxes/cashBox/profile/cashBoxMenu.vue') : import(/* webpackChunkName: "desktopTreasuryCashBox" */ '@/desktop/views/admin/treasury/cashBoxes/cashBox/profile/cashBoxMenu.vue') },
              meta: {
                permission: 'cash.show',
                pageTitle: 'صندوق',
                pageTitleI18n: 'pages.treasury.cashBoxes.cashBox.title',
                layoutStatus: 'profile'
              // rule: 'editor'
              }
            },
            {
              path: 'edit',
              name: 'editTreasuryCashBox',
              component: () => import(/* webpackChunkName: "editTreasuryCashBox" */ '../../../views/admin/treasury/cashBoxes/cashBox/edit/editCashBox.vue'),
              meta: {
                permission: 'cash.update',
                pageTitle: 'ویرایش صندوق',
                pageTitleI18n: 'pages.treasury.cashBoxes.edit.title',
                layoutStatus: 'profile'
              // rule: 'editor'
              }
            },
            {
              path: 'transactions',
              name: 'transactionsTreasuryCashBox',
              component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileTreasuryCashBoxTransactions" */ '@/mobile/views/admin/treasury/cashBoxes/cashBox/transactions/cashBoxTransactions.vue') : import(/* webpackChunkName: "desktopTreasuryCashBoxTransactions" */ '@/desktop/views/admin/treasury/cashBoxes/cashBox/transactions/cashBoxTransactions.vue') },
              meta: {
                permission: 'cash.show',
                pageTitle: 'گزارشات صندوق',
                pageTitleI18n: 'pages.treasury.cashBoxes.transactions.title',
                layoutStatus: 'profile'
              // rule: 'editor'
              }
            },
            {
              path: 'activities-log',
              name: 'activitiesLogCashBox',
              component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileCashBoxActivitiesLog" */ '@/mobile/views/admin/treasury/cashBoxes/cashBox/activitiesLog/cashBoxActivitiesLog.vue') : import(/* webpackChunkName: "desktopCashBoxActivitiesLog" */ '@/desktop/views/admin/treasury/cashBoxes/cashBox/activitiesLog/cashBoxActivitiesLog.vue') },
              meta: {
                permission: 'activity_logs.show',
                pageTitle: 'لاگ های صندوق',
                pageTitleI18n: 'pages.treasury.cashBoxes.logs.title',
                layoutStatus: 'profile'
              // rule: 'editor'
              }
            }
          ]
        }
      ]
    },
    {
      path: 'receive',
      component: () => import('../../../views/admin/treasury/receive/index.vue'),
      children: [
        {
          path: '',
          name: 'treasuryReceive',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileReceives" */ '@/mobile/views/admin/treasury/receive/list/receivesList.vue') : import(/* webpackChunkName: "desktopReceives" */ '@/desktop/views/admin/treasury/receive/list/receivesList.vue') },
          meta: {
            pageTitle: 'دریافت',
            pageTitleI18n: 'pages.treasury.receive.list.title'
          // rule: 'editor'
          }
        },
        {
          path: 'trash',
          name: 'treasuryReceiveTrash',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileReceiveTrash" */ '@/mobile/views/admin/treasury/receive/trash/receivesTrash.vue') : import(/* webpackChunkName: "desktopReceiveTrash" */ '@/desktop/views/admin/treasury/receive/trash/receivesTrash.vue') },
          meta: {
            pageTitle: 'دریافت',
            pageTitleI18n: 'pages.treasury.receive.trash.title'
          // rule: 'editor'
          }
        },
        {
          path: 'insert',
          name: 'insertTreasuryReceive',
          component: () => import(/* webpackChunkName: "insertTreasuryReceive" */ '../../../views/admin/treasury/receive/insert/insertReceive.vue'),
          meta: {
            pageTitle: 'دریافت',
            pageTitleI18n: 'pages.treasury.receive.insert.title'
          // rule: 'editor'
          }
        },
        {
          path: 'doc-:id',
          component: () => import(/* webpackChunkName: "treasuryReceive" */ '../../../views/admin/treasury/receive/index.vue'),
          meta: {
            redirectNotFound: true
          },
          children: [
            {
              path: '',
              name: 'treasuryReceiveDocument',
              component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileReceiveDocument" */ '@/mobile/views/admin/treasury/receive/document/receiveDocument.vue') : import(/* webpackChunkName: "desktopReceiveDocument" */ '@/desktop/views/admin/treasury/receive/document/receiveDocument.vue') },
              meta: {
                pageTitle: 'سند دریافت',
                pageTitleI18n: 'pages.treasury.receive.document.title'
              // rule: 'editor'
              }
            },
            {
              path: 'return',
              name: 'treasuryRefundReceiveDocument',
              component: () => import(/* webpackChunkName: "treasuryRefundReceiveDocument" */ '../../../views/admin/treasury/receive/return/insertReturnReceive.vue'),
              meta: {
                pageTitle: 'سند دریافت',
                pageTitleI18n: 'pages.treasury.receive.return.title'
              // rule: 'editor'
              }
            },
            {
              path: 'activities-log',
              name: 'receiveActivitiesLog',
              component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileReceiveActivitiesLog" */ '@/mobile/views/admin/treasury/receive/activitiesLog/receiveActivitiesLog.vue') : import(/* webpackChunkName: "desktopReceiveActivitiesLog" */ '@/desktop/views/admin/treasury/receive/activitiesLog/receiveActivitiesLog.vue') },
              meta: {
                permission: 'activity_logs.show',
                pageTitle: 'لاگ های دریافت',
                pageTitleI18n: 'pages.treasury.receive.logs.title'
              // rule: 'editor'
              }
            }
          ]
        }
      ]
    },
    {
      path: 'payment',
      component: () => import('../../../views/admin/treasury/payment/index.vue'),
      children: [
        {
          path: '',
          name: 'treasuryPayment',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobilePayments" */ '@/mobile/views/admin/treasury/payment/list/paymentsList.vue') : import(/* webpackChunkName: "desktopPayments" */ '@/desktop/views/admin/treasury/payment/list/paymentsList.vue') },
          meta: {
            pageTitle: 'پرداخت',
            pageTitleI18n: 'pages.treasury.payment.list.title'
          // rule: 'editor'
          }
        },
        {
          path: 'trash',
          name: 'treasuryPaymentTrash',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobilePaymentTrash" */ '@/mobile/views/admin/treasury/payment/trash/paymentsTrash.vue') : import(/* webpackChunkName: "desktopPaymentTrash" */ '@/desktop/views/admin/treasury/payment/trash/paymentsTrash.vue') },
          meta: {
            pageTitle: 'پرداخت',
            pageTitleI18n: 'pages.treasury.payment.trash.title'
          // rule: 'editor'
          }
        },
        {
          path: 'insert',
          name: 'insertTreasuryPayment',
          component: () => import(/* webpackChunkName: "insertTreasuryPayment" */ '../../../views/admin/treasury/payment/insert/insertPayment.vue'),
          meta: {
            pageTitle: 'پرداخت جدید',
            pageTitleI18n: 'pages.treasury.payment.insert.title'
          // rule: 'editor'
          }
        },
        {
          path: 'doc-:id',
          name: 'treasuryPaymentDocument',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobilePaymentDocument" */ '@/mobile/views/admin/treasury/payment/document/paymentDocument.vue') : import(/* webpackChunkName: "desktopPaymentDocument" */ '@/desktop/views/admin/treasury/payment/document/paymentDocument.vue') },
          meta: {
            pageTitle: 'سند پرداخت',
            pageTitleI18n: 'pages.treasury.payment.document.title',
            redirectNotFound: true
          // rule: 'editor'
          }
        },
        {
          path: 'doc-:id/activities-log',
          name: 'paymentActivitiesLog',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobilePaymentActivitiesLog" */ '@/mobile/views/admin/treasury/payment/activitiesLog/paymentActivitiesLog.vue') : import(/* webpackChunkName: "desktopPaymentActivitiesLog" */ '@/desktop/views/admin/treasury/payment/activitiesLog/paymentActivitiesLog.vue') },
          meta: {
            permission: 'activity_logs.show',
            pageTitle: 'لاگ های پرداخت',
            pageTitleI18n: 'pages.treasury.payment.logs.title',
            redirectNotFound: true
          // rule: 'editor'
          }
        }
      ]
    },
    {
      path: 'internal-funds-transfers',
      component: () => import('../../../views/admin/treasury/InternalFundsTransfer/index.vue'),
      children: [
        {
          path: '',
          name: 'treasuryInternalFundsTransfers',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileInternalFundsTransfers" */ '@/mobile/views/admin/treasury/InternalFundsTransfer/list/internalFundsTransfersList.vue') : import(/* webpackChunkName: "desktopInternalFundsTransfers" */ '@/desktop/views/admin/treasury/InternalFundsTransfer/list/internalFundsTransfersList.vue') },
          meta: {
            pageTitle: 'انتقالی خزانه',
            pageTitleI18n: 'pages.treasury.internalFundsTransfer.title'
          // rule: 'editor'
          }
        },
        {
          path: 'trash',
          name: 'treasuryInternalFundsTransfersTrash',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileInternalFundsTransfersTrash" */ '@/mobile/views/admin/treasury/InternalFundsTransfer/trash/internalFundsTransfersTrash.vue') : import(/* webpackChunkName: "desktopInternalFundsTransfersTrash" */ '@/desktop/views/admin/treasury/InternalFundsTransfer/trash/internalFundsTransfersTrash.vue') },
          meta: {
            pageTitle: 'انتقالی خزانه',
            pageTitleI18n: 'pages.treasury.internalFundsTransfer.trash.title'
          // rule: 'editor'
          }
        },
        {
          path: 'doc-:id',
          name: 'treasuryInternalFundsTransferDocument',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileInternalFundsTransferDocument" */ '@/mobile/views/admin/treasury/InternalFundsTransfer/document/internalFundsTransferDocument.vue') : import(/* webpackChunkName: "desktopInternalFundsTransferDocument" */ '@/desktop/views/admin/treasury/InternalFundsTransfer/document/internalFundsTransferDocument.vue') },
          meta: {
            pageTitle: 'انتقالی خزانه',
            pageTitleI18n: 'pages.treasury.internalFundsTransfer.document.title',
            redirectNotFound: true
          // rule: 'editor'
          }
        },
        {
          path: 'insert',
          name: 'insertTreasuryInternalFundsTransfers',
          component: () => import(/* webpackChunkName: "insertTreasuryInternalFundsTransfers" */ '../../../views/admin/treasury/InternalFundsTransfer/insert/insertInternalFundsTransfer.vue'),
          meta: {
            pageTitle: 'انتقالی خزانه جدید',
            pageTitleI18n: 'pages.treasury.internalFundsTransfer.insert.title'
          // rule: 'editor'
          }
        },
        {
          path: 'doc-:id/activities-log',
          name: 'internalFundsTransfersActivitiesLog',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileInternalFundActivitiesLog" */ '@/mobile/views/admin/treasury/InternalFundsTransfer/activitiesLog/internalFundActivitiesLog.vue') : import(/* webpackChunkName: "desktopInternalFundActivitiesLog" */ '@/desktop/views/admin/treasury/InternalFundsTransfer/activitiesLog/internalFundActivitiesLog.vue') },
          meta: {
            permission: 'activity_logs.show',
            pageTitle: 'لاگ های انتقالی خرانه',
            pageTitleI18n: 'pages.treasury.internalFundsTransfer.logs.title',
            redirectNotFound: true
          // rule: 'editor'
          }
        }
      ]
    }
  ]
}
